// extracted by mini-css-extract-plugin
module.exports = {"ratingArrow":"SortArrow_ratingArrow__2GEHg"};